/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/*
 * SiteSpecificDigitalPassesMapSection.jsx
 * Created by Destin Frasier on 12/12/18
 */

import React from 'react';
import PropTypes from 'prop-types';
import mapboxgl from 'mapbox-gl';
import {
    FlexRow,
    FlexCol,
    NoMapboxGlNotice,
    ScrollableList,
    ScrollableListItem,
    TextField,
    Icon,
    Button,
} from 'sarsaparilla';
import isEmpty from 'lodash/isEmpty';
import BasicMap from 'shared-ui/maps/templates/BasicMap';
import { convertSearchResultToGeoJson } from '../../utils/mapHelper';

const defaultProps = {
    facilities: [],
    facility: '',
};
const propTypes = {
    facility: PropTypes.string,
    facilities: PropTypes.array,
    filteredFacilities: PropTypes.array,
    onChange: PropTypes.func,
};

export default class SiteSpecificDigitalPassesMapSection extends React.PureComponent {
    render() {
        const { facilities, facility, filteredFacilities, onChange } = this.props;
        const isMapboxGlSupported = mapboxgl.supported();
        const passGeoJsonData = convertSearchResultToGeoJson(filteredFacilities);
        const mapRest = isEmpty(filteredFacilities) ? {} : { geojson: passGeoJsonData };
        return (
            <div className="pass-site-specific-map-background">
                <div className="pass-site-specific-map-list-wrap">
                    <FlexRow justifyContent="end" hasGutters={false}>
                        <FlexCol
                            md={10}
                            lg={9}
                            xl={8}
                            className="mx-2 mx-sm-3 mx-lg-0 mr-lg-3"
                        >
                            <Button
                                appearance="tertiary"
                                size="sm"
                                className="mb-2 p-1 pass-site-skip-search"
                                href="#skip-to-interagency"
                            >
                                Skip to Interagency Passes
                            </Button>
                            <TextField
                                id="map-filter-input"
                                label="Search by name, location or state"
                                value={facility}
                                onChange={onChange}
                                iconElement={<Icon iconName="search" />}
                                hasClearButton
                            />

                            <ScrollableList
                                maxHeight={630}
                                className="map-specific-pass-filter"
                                // aria-label="Location list items"
                            >
                                {!isEmpty(facilities) ? (
                                    facilities.map(([label, item]) => (
                                        <li
                                            className="map-specific-pass-scroll-location-block"
                                            key={`state-${label}`}
                                        >
                                            <ul>
                                                <ScrollableListItem>
                                                    {label}
                                                </ScrollableListItem>
                                            </ul>
                                            <ul className="map-specific-pass-scroll-list">
                                                {item.map((val) => (
                                                    <li key={`facilty-${val.id}`}>
                                                        <a
                                                            aria-label={`${val.name}`}
                                                            href={`/sitepass/${val.id}`}
                                                        >
                                                            {val.name}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                    ))
                                ) : (
                                    <p className="map-specific-pass-no-results">
                                        No Results Available. Please adjust your search
                                        and try again.
                                    </p>
                                )}
                            </ScrollableList>
                        </FlexCol>
                    </FlexRow>
                </div>

                <div className="site-specific-map-inner-wrap">
                    {isMapboxGlSupported && (
                        <div id="Mapbox" className="map">
                            <BasicMap
                                center={[-98.585522, 39.8333333]}
                                mapContainer="Mapbox"
                                zoom={3.5}
                                service="pass"
                                skipMapFitBounds={true}
                                {...mapRest}
                            />

                            {!isMapboxGlSupported && <NoMapboxGlNotice />}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

SiteSpecificDigitalPassesMapSection.propTypes = propTypes;
SiteSpecificDigitalPassesMapSection.defaultProps = defaultProps;
